import { render, staticRenderFns } from "./PageTopButton.vue?vue&type=template&id=f74bfeca&"
import script from "./PageTopButton.vue?vue&type=script&lang=ts&"
export * from "./PageTopButton.vue?vue&type=script&lang=ts&"
import style0 from "./PageTopButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports